module.exports = __webpack_public_path__ + "img/product3-1.6c20acbc.jpg";